var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_2089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 2C76.5097 2 98 23.4903 98 50C98 76.5097 76.5097 98 50 98C23.4903 98 2 76.5097 2 50C2 23.4903 23.4903 2 50 2Z",
    fill: "#3B6B94",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9883 52.4688L23.6328 39.3203V65.4453C23.6364 66.7698 24.1642 68.0389 25.1007 68.9755C26.0372 69.912 27.3064 70.4398 28.6309 70.4434H71.3691C72.6936 70.4398 73.9628 69.912 74.8993 68.9755C75.8358 68.0389 76.3636 66.7698 76.3672 65.4453V39.5957L49.9883 52.4688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0117 47.5312L76.3672 34.668V34.5547C76.3636 33.2302 75.8358 31.9611 74.8993 31.0245C73.9628 30.088 72.6936 29.5602 71.3691 29.5566H28.6309C27.3369 29.5592 26.094 30.0622 25.1624 30.9603C24.2308 31.8584 23.6827 33.082 23.6328 34.375L50.0117 47.5312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_2089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.0449ad7e508fd30884cba035d401e8fc.svg";
export { ForwardRef as ReactComponent };